import { render, staticRenderFns } from "./fileLayout.vue?vue&type=template&id=5904d08d&"
import script from "./fileLayout.vue?vue&type=script&lang=ts&"
export * from "./fileLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports